import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot01 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 8,
		fill: "currentColor"
	})
});
export default SvgDot01;
